const questionList = [
    {
        "questionText": "Wich country are you in if you are visiting Macchu Picchu?",
        "answerOptions": [
            {
                "answerText": "Chile",
                "rightChoice": false
            }, {
                "answerText": "Panama",
                "rightChoice": false
            }, {
                "answerText": "Peru",
                "rightChoice": true
            }, {
                "answerText": "Colombia",
                "rightChoice": false
            }
        ]
    },
    {
        "questionText": "Which country are you in if you're on the largest island in the world?",
        "answerOptions": [
            {
                "answerText": "Japan",
                "rightChoice": false
            }, {
                "answerText": "Greenland",
                "rightChoice": true
            }, {
                "answerText": "Philippines",
                "rightChoice": false
            }, {
                "answerText": "New Zealand",
                "rightChoice": false
            }
        ]
    },
    {
        "questionText": "What country are you in if you find the currency baht?",
        "answerOptions": [
            {
                "answerText": "Philippines",
                "rightChoice": false
            }, {
                "answerText": "Myanmar",
                "rightChoice": false
            }, {
                "answerText": "Vietnam",
                "rightChoice": false
            }, {
                "answerText": "Thailand",
                "rightChoice": true
            }
        ]
    },
    {
        "questionText": "What country is Phnom Penh the capital of?",
        "answerOptions": [
            {
                "answerText": "Cambodia",
                "rightChoice": true
            }, {
                "answerText": "Oman",
                "rightChoice": false
            }, {
                "answerText": "Australia",
                "rightChoice": false
            }, {
                "answerText": "Greece",
                "rightChoice": false
            }
        ]
    }, {
        "questionText": "The first modern Olympic Games were held in which country?",
        "answerOptions": [
            {
                "answerText": "Sweden",
                "rightChoice": false
            }, {
                "answerText": "Greece",
                "rightChoice": true
            }, {
                "answerText": "Australia",
                "rightChoice": false
            }, {
                "answerText": "India",
                "rightChoice": false
            }
        ]
    }, {
        "questionText": "Where is the Gobi Desert located?",
        "answerOptions": [
            {
                "answerText": "Cuba",
                "rightChoice": false
            }, {
                "answerText": "Mongolia",
                "rightChoice": true
            }, {
                "answerText": "Holland",
                "rightChoice": false
            }, {
                "answerText": "Japan",
                "rightChoice": false
            }
        ]
    }, {
        "questionText": "The country which most offical languages is...",
        "answerOptions": [
            {
                "answerText": "Zimbabwe",
                "rightChoice": false
            }, {
                "answerText": "India",
                "rightChoice": false
            }, {
                "answerText": "Singapore",
                "rightChoice": false
            }, {
                "answerText": "Bolivia",
                "rightChoice": true
            }
        ]
    }, {
        "questionText": "Which country has the most pyramids in the world?",
        "answerOptions": [
            {
                "answerText": "Egypt",
                "rightChoice": false
            }, {
                "answerText": "Peru",
                "rightChoice": false
            }, {
                "answerText": "Sudan",
                "rightChoice": true
            }, {
                "answerText": "Mexico",
                "rightChoice": false
            }
        ]
    }, {
        "questionText": "Which country has the driest place on Earth?",
        "answerOptions": [
            {
                "answerText": "Niger",
                "rightChoice": false
            }, {
                "answerText": "Saudi Arabia",
                "rightChoice": false
            }, {
                "answerText": "Egypt",
                "rightChoice": false
            }, {
                "answerText": "Chile",
                "rightChoice": true
            }
        ]
    }, {
        "questionText": "The World's Shortest River is located on...",
        "answerOptions": [
            {
                "answerText": "United States of America",
                "rightChoice": true
            }, {
                "answerText": "Liechtenstein",
                "rightChoice": false
            }, {
                "answerText": "Portugal",
                "rightChoice": false
            }, {
                "answerText": "Chad",
                "rightChoice": false
            }
        ]
    }
]

export default questionList
